import apiClient from '../apiClient';
import { POST_SET_PRIMARY_RESTAURANT_PROFILE_URL } from '../apiUrl';

const postSetPrimaryImageRestaurantProfileApi = (id, data) => {
  return apiClient.post(POST_SET_PRIMARY_RESTAURANT_PROFILE_URL(id), data);
};

export default postSetPrimaryImageRestaurantProfileApi;
